import type { Language } from '@/types';

export const fmtAMD = (n: number): string => `${n.toLocaleString('en-US')} AMD`;

const MONTHS: Record<Language, readonly string[]> = {
  en: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
  hy: ['ՀՆՎ', 'ՓՏՎ', 'ՄՐՏ', 'ԱՊՐ', 'ՄՅՍ', 'ՀՆՍ', 'ՀԼՍ', 'ՕԳՍ', 'ՍԵՊ', 'ՀՈԿ', 'ՆՈՅ', 'ԴԵԿ'],
  ru: ['ЯНВ', 'ФЕВ', 'МАР', 'АПР', 'МАЙ', 'ИЮН', 'ИЮЛ', 'АВГ', 'СЕН', 'ОКТ', 'НОЯ', 'ДЕК'],
};

export interface FormattedDate {
  day: string;
  month: string;
  year: number;
  iso: string;
}

export const fmtDate = (iso: string, lang: Language = 'en'): FormattedDate => {
  const d = new Date(`${iso}T00:00:00`);
  const months = MONTHS[lang] ?? MONTHS.en;
  const month = months[d.getMonth()] ?? '';
  const day = String(d.getDate()).padStart(2, '0');
  return { day, month, year: d.getFullYear(), iso };
};

export const fmtDateCompact = (iso: string): string => {
  const d = new Date(`${iso}T00:00:00`);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}-${mm}-${d.getFullYear()}`;
};

export const daysFromNow = (iso: string): number => {
  const target = new Date(`${iso}T00:00:00`).getTime();
  return Math.round((target - Date.now()) / 86_400_000);
};

export interface Countdown {
  d: string;
  h: string;
  m: string;
  s: string;
}

export const getCountdown = (iso: string): Countdown => {
  const target = new Date(`${iso}T22:00:00`).getTime();
  let diff = Math.max(0, target - Date.now());
  const days = Math.floor(diff / 86_400_000);
  diff -= days * 86_400_000;
  const hrs = Math.floor(diff / 3_600_000);
  diff -= hrs * 3_600_000;
  const min = Math.floor(diff / 60_000);
  diff -= min * 60_000;
  const sec = Math.floor(diff / 1000);
  return {
    d: String(days).padStart(3, '0'),
    h: String(hrs).padStart(2, '0'),
    m: String(min).padStart(2, '0'),
    s: String(sec).padStart(2, '0'),
  };
};
